export default __webpack_public_path__ + "static/media/star-white.18981e77.svg";